<div class="banner-dollar">
  <div class="picture" *ngIf="!isMobile">
    <div class="border"></div>
  </div>
  <div class="info">
    <div class="advice">
      <mb-advice color="secondary" align="left">
        <p>¡Nuevo método de pago!</p>
      </mb-advice>
    </div>
    <h3 class="title">Ahora podés pagar<br />con efectivo en dólares</h3>
    <p class="link">
      en cualquiera de
      <a href="https://almundo.com.ar/v2/experts/sucursales" target="_blank">nuestras sucursales</a>
    </p>
  </div>
</div>
